import { makeRequest } from 'utils/requestLogger';

const success = (res) => {
  console.log('grade submission success', res);
};

// When the request fails
const failed = (error) => {
  console.log('grade submission failed', error);
};

export default (submissionID, evaluation) => {
  makeRequest('put', `/api/submissions/${submissionID}/evaluate`, evaluation)
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      failed(error);
    });
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/gradeSubmission.js